export default __webpack_public_path__ + "static/media/amaze-3.b8f8d16b.jpg";